import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// Fundo azul em largura total
const Container = styled.section`
  width: 100vw;
  background: linear-gradient(90deg, #274FA3 0%, #002776 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 64px 132px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 40px 20px;
    align-items: center;
  }
`;

// Conteúdo centralizado
const InnerContent = styled.div`
  width: 100%;
  max-width: 1440px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
    align-items: center;
  }
`;

// Bloco da esquerda com motivos
const FeatureBox = styled.div`
  flex: 1;
  color: #B6C7E9;
  font-family: 'Montserrat', sans-serif;

  h2 {
    font-size: 40px;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 40px;

    @media (max-width: 768px) {
      font-size: 28px;
      text-align: center;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
  }

  li {
    font-size: 16px;
    margin-bottom: 12px;

    @media (max-width: 768px) {
      text-align: center;
    }
  }
`;

// Box branco dos depoimentos com ajuste refinado
const TestimonialBox = styled.div`
  width: 474px;
  height: 218px;
  background: #FFFFFF;
  box-shadow: 12px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  font-family: 'Montserrat', sans-serif;

  p {
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    text-align: left;
  }

  strong {
    font-size: 14px;
    text-align: left;
    color: #002776;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 32px 16px;
    box-shadow: none;

    p, strong {
      text-align: center;
    }
  }
`;

const testimonials = [
  {
    text: "Agendamentos de exames com muita facilidade, preço acessível ao nosso bolso, minha mãe é aposentada sem condições de pagar um convênio , o cartão nação saúde foi maravilhoso, hoje ela consegue fazer exames médicos com preços bem acessíveis. Bem mais vantajoso que pagar um plano de saúde para idosa de 75 anos.",
    author: "Rosangela Bueno - Empresa Digycon"
  },
  {
    text: "A CNS é mais que um parceiro necessário! Necessário porque oferece acesso a serviços essenciais de saúde e bem estar, mas é mais que isso porque oferece autonomia e menos burocracia nessa operação. Além da qualidade, agilidade e facilidade em todo processo, da contratação ao uso dos parceiros!",
    author: "Gustavo Loreiro Gomes - Empresa Hug"
  },
  {
    text: "Com o Cartão Nação Saúde, minha rotina mudou para melhor. Hoje, economizo em exames, consultas médicas e até nas compras de farmácia. Além disso, não preciso mais enfrentar as longas filas de atendimento no UPA. Quando preciso, sou atendido rapidamente por telemedicina, com profissionais do Hospital Albert Einstein, sem sair de casa. É praticidade, qualidade e economia em um único benefício.",
    author: "Gabriel Guerra - Cliente B2C"
  }
];

export default function NacaoSaudeSection() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Container>
      <InnerContent>
        <FeatureBox>
          <h2>Por que escolher a Nação Saúde</h2>
          <ul>
            <li>Mais de 12.000 tipos de exames disponíveis</li>
            <li>Atendimento com médicos do Einstein</li>
            <li>Rede com +12.000 credenciados (Dasa, Fleury, FEME e outros)</li>
            <li>Aprovado por milhares de brasileiros em mais de 300 cidades</li>
            <li>Capilaridade nacional e sem carência</li>
            <li>Sem juros e sem multa contratual</li>
          </ul>
        </FeatureBox>

        <TestimonialBox>
          <p>“{testimonials[index].text}”</p>
          <strong>{testimonials[index].author}</strong>
        </TestimonialBox>
      </InnerContent>
    </Container>
  );
}
